import React from 'react';
import { Table } from 'semantic-ui-react';

export default function TopicMessagesTableHeader(props) {
	return (
		<Table.Row>
			<Table.HeaderCell
				width={1}
				sorted={props.column === 'sequenceNumber' ? props.direction : null}
				// onClick={() => props.handleSort('topicID')}
			>
				SEQUENCE NUMBER
			</Table.HeaderCell>
			<Table.HeaderCell
				width={1}
				sorted={props.column === 'createdBy' ? props.direction : null}
				// onClick={() => props.handleSort('createdBy')}
			>
				SUBMITTED BY
			</Table.HeaderCell>
			{/* <Table.HeaderCell
				width={1}
				sorted={props.column === 'createdDate' ? props.direction : null}
				// onClick={() => props.handleSort('createdDate')}
			>
				TIME SUBMITTED
			</Table.HeaderCell> */}
			{/* <Table.HeaderCell
				width={1}
				sorted={props.column === 'transactionID' ? props.direction : null}
				onClick={() => props.handleSort('transactionID')}
			>
				Transaction ID
			</Table.HeaderCell> */}
			{/* <Table.HeaderCell
				sorted={props.column === 'memo' ? props.direction : null}
				onClick={() => props.handleSort('memo')}
			>
				Memo
			</Table.HeaderCell> */}
			<Table.HeaderCell width={1} />
		</Table.Row>
	);
}
